import React from 'react';

import './NavigationBreadcrumbs.scss';


class NavigationBreadcrumbs extends React.Component {
  renderBreadcrumb(breadcrumb) {
    return (breadcrumb.href !== null) ?
      <a href={breadcrumb.href}>{breadcrumb.title}</a>
      :
      <span>{breadcrumb.title}</span>
  }

  render() {
    const {
      breadcrumbs = []
    } = this.props;

    return (
      <div className="parkchirp--navigation-breadcrumbs-container">
        <ul className="parkchirp--navigation-breadcrumbs">
          {breadcrumbs.map((breadcrumb, index) => {
            return (
              <li key={index} className={breadcrumb.title === 'Universal Search' ? 'universal-search-link' : ''}>
                {this.renderBreadcrumb(breadcrumb)}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}
export default NavigationBreadcrumbs;
